import { createFileRoute } from '@tanstack/react-router';

import { InvoiceV2RejectionView } from '~/modules/invoice/v2/detail/rejection/InvoiceV2RejectionView';

export const Route = createFileRoute(
  '/(main)/invoices/v2/incoming/$invoiceId/reject/',
)({
  component: InvoiceV2RejectionView,
});
